"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onGetCurrentProjectSuccess = exports.onSendProjectScreenshot = void 0;
const project_1 = require("~/store/api/project");
const projectSharing_1 = require("~/utils/projectSharing");
const effects_1 = require("redux-saga/effects");
const utils_1 = require("~/utils/utils");
const types_1 = require("~/store/types");
const api_1 = require("~/store/api");
const events_1 = require("~/utils/events");
const project_json_1 = __importDefault(require("~/locales/en/project.json"));
const actions_1 = require("~/store/project/actions");
const actions_2 = require("~/store/widgets/content/bom/actions");
const accessUtils_1 = __importDefault(require("~/utils/accessUtils"));
const consts_1 = require("./consts");
const consts_2 = require("../account/consts");
const isUserLoggedState = (state) => state.authenticate.data.isUserLogged;
const getProjectId = (state) => { var _a; return (_a = state.project.currentProject) === null || _a === void 0 ? void 0 : _a.id; };
const getUserId = (state) => { var _a, _b; return (_b = (_a = state.authenticate.data) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.id; };
const getBOMLoading = (state) => state.bom.isLoading;
const getUserType = (state) => { var _a, _b, _c; return (_c = (_b = (_a = state.authenticate.data) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userType) === null || _c === void 0 ? void 0 : _c.name; };
const getUser = (state) => { var _a; return (_a = state.authenticate.data) === null || _a === void 0 ? void 0 : _a.user; };
function getViewMode(project, user) {
    if (!project) {
        return 'edit';
    }
    if (!user) {
        return 'view';
    }
    const isProjectViewOnly = !(0, accessUtils_1.default)(user, project) || (!!project.lockedById && user.id !== project.lockedById);
    const viewMode = isProjectViewOnly ? 'view' : 'edit';
    return viewMode;
}
function* onGetCurrentProject({ payload }) {
    var _a, _b, _c, _d;
    try {
        const project = yield (0, effects_1.call)(api_1.getFullProject, payload.projectId);
        const userId = yield (0, effects_1.select)(getUserId);
        const user = yield (0, effects_1.select)(getUser);
        if (project.lockedById && project.lockedById !== userId && payload.optionHandlerMatch) {
            yield (0, effects_1.call)(events_1.showNotification, {
                message: `The project is locked by ${(_a = project.lockedBy) === null || _a === void 0 ? void 0 : _a.firstName} ${(_b = project.lockedBy) === null || _b === void 0 ? void 0 : _b.lastName}.`,
                type: 'warning',
            });
        }
        yield (0, effects_1.call)(utils_1.setProjectOnScene, project.quotes[0].projectItems);
        const projectId = yield (0, effects_1.select)(getProjectId);
        if (projectId && projectId !== project.id) {
            yield (0, effects_1.call)(api_1.closeProject, projectId);
        }
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectSuccess)(project));
        const viewMode = getViewMode(project, user);
        if (!project.lockedById && payload.optionHandlerMatch && viewMode === 'edit') {
            yield (0, effects_1.put)((0, actions_1.requestSocketLockProject)({ projectId: project.id, userId }));
        }
        const BOMLoading = yield (0, effects_1.select)(getBOMLoading);
        if (BOMLoading !== types_1.LOADING_STATE.LOADING) {
            yield (0, effects_1.put)((0, actions_2.requestSocketBOM)({ projectId: project.id, userId }));
        }
    }
    catch (error) {
        const message = ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || 'Couldn’t load the project. Please refresh and contact support if it continues.';
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectFailed)());
        yield (0, effects_1.call)(events_1.showNotification, {
            message,
            type: 'error',
        });
    }
}
let draftScreenshot = null;
function* onSendProjectScreenshot({ payload }) {
    try {
        const project = yield (0, effects_1.select)((state) => state.project.currentProject);
        const user = yield (0, effects_1.select)(getUser);
        // Drafts are edited through their bound socket. HTTP uploads start after the ownership acknowledgment.
        if (!(project === null || project === void 0 ? void 0 : project.user_id)) {
            if (project === null || project === void 0 ? void 0 : project.id) {
                draftScreenshot = { projectId: project.id, data: payload };
            }
            return;
        }
        if (!(0, accessUtils_1.default)(user, project)) {
            return;
        }
        const projectId = yield (0, effects_1.select)(getProjectId);
        yield (0, effects_1.call)(api_1.postScreenshot, payload, projectId);
    }
    catch (error) {
        console.log(error);
    }
}
exports.onSendProjectScreenshot = onSendProjectScreenshot;
function* onGetCurrentProjectSuccess({ payload, sessionToken }) {
    const isUserLogged = yield (0, effects_1.select)(isUserLoggedState);
    if (sessionToken && !isUserLogged) {
        yield (0, effects_1.call)(utils_1.setSessionToken, sessionToken);
    }
    const user = yield (0, effects_1.select)(getUser);
    const viewMode = getViewMode(payload, user);
    yield (0, effects_1.put)((0, actions_1.setViewMode)(viewMode));
    if (draftScreenshot &&
        (payload === null || payload === void 0 ? void 0 : payload.id) === draftScreenshot.projectId &&
        payload.user_id &&
        (0, accessUtils_1.default)(user, payload)) {
        const screenshot = draftScreenshot;
        draftScreenshot = null;
        yield (0, effects_1.call)(onSendProjectScreenshot, { type: consts_1.SEND_PROJECT_SCREENSHOT, payload: screenshot.data });
    }
}
exports.onGetCurrentProjectSuccess = onGetCurrentProjectSuccess;
function* onDuplicateProject({ payload }) {
    try {
        const response = yield (0, effects_1.call)(api_1.duplicateProject, payload);
        const projectId = yield (0, effects_1.select)(getProjectId);
        if (projectId) {
            yield (0, effects_1.call)(api_1.closeProject, projectId);
        }
        yield (0, effects_1.put)((0, actions_1.duplicateProjectSuccess)(response));
        yield (0, effects_1.call)(events_1.showNotification, {
            message: `${response.name} ${project_json_1.default['project-was-successfully-duplicated']}`,
            type: 'success',
        });
        const userId = yield (0, effects_1.select)(getUserId);
        // TODO: Refactor solution to maintain information about duplicated project
        // eslint-disable-next-line no-restricted-globals
        location.href = `/projects/${response.id}`;
        yield (0, effects_1.put)((0, actions_2.setBomSubmitDisabled)(false));
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectSuccess)(response));
        yield (0, effects_1.put)((0, actions_1.getProjectSuccess)(response));
        yield (0, effects_1.put)((0, actions_2.requestSocketBOM)({ projectId: response.id, userId }));
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectFailed)());
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onCreateProject({ payload }) {
    try {
        const userType = yield (0, effects_1.select)(getUserType);
        const userId = yield (0, effects_1.select)(getUserId);
        if (userType === consts_2.UserRoles.customer) {
            // eslint-disable-next-line no-param-reassign
            payload.customerId = userId;
        }
        const response = yield (0, effects_1.call)(api_1.createProject, payload);
        yield (0, effects_1.call)(events_1.showNotification, {
            message: `${response.name} ${project_json_1.default['project-was-successfully-created']}`,
            type: 'success',
        });
        const projectId = yield (0, effects_1.select)(getProjectId);
        if (projectId) {
            yield (0, effects_1.call)(api_1.closeProject, projectId);
        }
        yield (0, effects_1.put)((0, actions_1.createProjectSuccess)(response));
        yield (0, effects_1.put)((0, actions_2.setBomSubmitDisabled)(false));
        yield (0, effects_1.put)((0, actions_1.setViewMode)('edit'));
        yield (0, effects_1.put)((0, actions_1.requestSocketLockProject)({ projectId: response.id, userId }));
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectSuccess)(response));
        yield (0, effects_1.put)((0, actions_1.getProjectSuccess)(response));
        yield (0, effects_1.put)((0, actions_2.setDefaultBOM)());
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectFailed)());
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onGetProject({ payload }) {
    try {
        const project = yield (0, effects_1.call)(api_1.getProject, payload);
        if (project) {
            yield (0, effects_1.put)((0, actions_1.getProjectSuccess)(project));
        }
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onUpdateProject({ payload }) {
    try {
        yield (0, effects_1.call)(api_1.updateProject, payload);
        yield (0, effects_1.put)((0, actions_1.editProjectSuccess)(true));
        const userId = yield (0, effects_1.select)(getUserId);
        yield (0, effects_1.put)((0, actions_2.requestSocketBOM)({ projectId: payload.id, userId }));
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onUpdateProjectWithoutBOM({ payload }) {
    try {
        yield (0, effects_1.call)(api_1.updateProject, payload);
        yield (0, effects_1.put)((0, actions_1.editProjectSuccess)(true));
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onReplaceCurrentProjectItems({ payload }) {
    try {
        const projectId = yield (0, effects_1.select)(getProjectId);
        if (!projectId) {
            return;
        }
        const response = yield (0, effects_1.call)(api_1.replaceProjectItems, Object.assign({ projectId }, payload));
        if (!response.status) {
            yield (0, effects_1.put)((0, actions_1.replaceCurrentProjectItemsFailed)());
        }
        yield (0, effects_1.call)(utils_1.replaceProjectItemsOnScene, payload);
        yield (0, effects_1.put)((0, actions_1.replaceCurrentProjectItemsSuccess)(payload));
        yield (0, effects_1.call)(events_1.showNotification, {
            message: `${project_json_1.default.notifications['current-project-items-were-successfully-updated']}`,
            type: 'success',
        });
        const userId = yield (0, effects_1.select)(getUserId);
        yield (0, effects_1.put)((0, actions_2.requestSocketBOM)({ projectId, userId }));
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_1.replaceCurrentProjectItemsFailed)());
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onDeleteProject({ payload }) {
    try {
        yield (0, effects_1.call)(api_1.deleteProject, payload);
        const currentProjectId = yield (0, effects_1.select)(getProjectId);
        if (currentProjectId === payload) {
            yield (0, effects_1.put)((0, actions_1.getCurrentProjectSuccess)(null));
            yield (0, effects_1.put)((0, actions_2.setDefaultBOM)());
            yield (0, effects_1.call)(utils_1.setProjectOnScene, []);
        }
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onCloseProject() {
    try {
        const projectId = yield (0, effects_1.select)(getProjectId);
        if (projectId) {
            yield (0, effects_1.call)(api_1.closeProject, projectId);
        }
        yield (0, effects_1.put)((0, actions_1.getCurrentProjectSuccess)(null));
        yield (0, effects_1.put)((0, actions_2.setDefaultBOM)());
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* onExportToStepSuccess({ payload }) {
    const errorMsg = 'Exporting project to STEP file failed. Please try again.';
    try {
        if (payload) {
            const blob = yield (0, effects_1.call)(project_1.getProjectAsset, payload.projectId, payload.fileName, 'exports');
            yield (0, effects_1.call)(projectSharing_1.saveProjectFile, blob, payload.fileName);
        }
        else {
            yield (0, effects_1.call)(events_1.showNotification, {
                message: (0, utils_1.errorify)(errorMsg),
                type: 'error',
            });
        }
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(errorMsg),
            type: 'error',
        });
    }
}
function* onRequestExportQueue() {
    try {
        const exportQueue = yield (0, effects_1.call)(api_1.getExportQueue);
        yield (0, effects_1.put)((0, actions_1.setExportQueue)(exportQueue));
    }
    catch (error) {
        yield (0, effects_1.call)(events_1.showNotification, {
            message: (0, utils_1.errorify)(error),
            type: 'error',
        });
    }
}
function* rootSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(consts_1.GET_CURRENT_PROJECT, onGetCurrentProject),
        (0, effects_1.takeLatest)(consts_1.GET_CURRENT_PROJECT_SUCCESS, onGetCurrentProjectSuccess),
        (0, effects_1.takeLatest)(consts_1.SEND_PROJECT_SCREENSHOT, onSendProjectScreenshot),
        (0, effects_1.takeLatest)(consts_1.CREATE_PROJECT, onCreateProject),
        (0, effects_1.takeLatest)(consts_1.GET_PROJECT, onGetProject),
        (0, effects_1.takeLatest)(consts_1.EDIT_PROJECT, onUpdateProject),
        (0, effects_1.takeLatest)(consts_1.EDIT_PROJECT_WITHOUT_BOM, onUpdateProjectWithoutBOM),
        (0, effects_1.takeLatest)(consts_1.DELETE_PROJECT, onDeleteProject),
        (0, effects_1.takeLatest)(consts_1.CLOSE_PROJECT, onCloseProject),
        (0, effects_1.takeLatest)(consts_1.DUPLICATE_PROJECT, onDuplicateProject),
        (0, effects_1.takeLatest)(consts_1.REQUEST_SOCKET_EXPORT_STEP_SUCCESS, onExportToStepSuccess),
        (0, effects_1.takeLatest)(consts_1.REQUEST_EXPORT_QUEUE, onRequestExportQueue),
        (0, effects_1.takeLatest)(consts_1.REQUEST_REPLACE_CURRENT_PROJECT_ITEMS, onReplaceCurrentProjectItems),
    ]);
}
exports.default = rootSaga;
